<template>
  <div>
    <!-- 检品列表-->
    <baseBreadcrumb :page="$t('message.listOfGoods')" :menu="$t('message.inspectionOfGoods')" />
    <section>
      <div class="header">
        <div class="headerContainer">
          <div class="tabs">
            <el-tabs v-model="datas.status" type="card" @tab-click="search">
              <!--  全部-->
              <el-tab-pane :label="$t('message.all')" name="0"></el-tab-pane>
              <!-- 待提交检品 -->
              <el-tab-pane :label="$t('message.goodsToBeSubmittedForInspection') + `(${inspectListTab['1']})`"
                name="1"></el-tab-pane>
              <!-- 待检品 -->
              <el-tab-pane :label="$t('message.waitingForGoods') + `(${inspectListTab['2']})`" name="2"></el-tab-pane>
              <!-- 检品中 -->
              <el-tab-pane :label="$t('message.underInspection') + `(${inspectListTab['3']})`" name="3"></el-tab-pane>
              <!-- 待布标处理 -->
              <el-tab-pane :label="$t('message.toBeClothLabelProcessing') + `(${inspectListTab['4']})`"
                name="4"></el-tab-pane>
              <!-- 布标处理中 -->
              <el-tab-pane :label="$t('message.clothLabelProcessing') + `(${inspectListTab['5']})`"
                name="5"></el-tab-pane>
              <!-- 待检品复查 -->
              <el-tab-pane :label="$t('message.productToBeInspected') + `(${inspectListTab['6']})`"
                name="6"></el-tab-pane>
              <!-- 检品完了 -->
              <el-tab-pane :label="$t('message.finishedGoods')" name="7"></el-tab-pane>
            </el-tabs>
          </div>
          <!-- 服务单 -->
          <div class="option" v-if="listTabCount != false">
            <!-- 服务待处理 -->
            <div class="item" v-for="(item, index) in listTabCount" :key="index" @click="optionList(item.key)"
              :class="{ optionKey: optionKey === item.key }">{{
                item.name }} ({{ item.count }})
            </div>
          </div>
          <div class="leftContainer" v-if="datas.status != -1">
            <div class="Container">
              <el-date-picker v-model="datas.dateStart" type="date" value-format="yyyy-MM-dd" clearable
                :placeholder="$t('message.startDate')">
              </el-date-picker>
            </div>
            <div class="Container">
              <el-date-picker v-model="datas.dateEnd" type="date" :placeholder="$t('message.dateClosed')"
                value-format="yyyy-MM-dd" clearable>
              </el-date-picker>
            </div>
            <!--物流号 -->
            <div class="Container">
              <el-input v-model="datas.express_no" clearable onfocus="this.select()"
                :placeholder="$t('message.pleaseEnterTheLogisticsNumber')"></el-input>
            </div>
            <!--交易号 -->
            <div class="Container">
              <el-input v-model="datas.purchase_no" clearable onfocus="this.select()"
                :placeholder="$t('message.pleaseEnterTransactionNumber')"></el-input>
            </div>
            <div class="Container">
              <!-- 订单号 -->
              <el-input v-model="datas.order_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.orderNumber')"></el-input>
            </div>
            <!-- 配送单号：列表接口参数 porder_sn -->
            <div class="Container">
              <el-input v-model="datas.porder_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.pleaseEnterTheShippingNumber')"></el-input>
            </div>
            <!--客户ID -->
            <div class="Container">
              <el-input v-model="datas.user_id" clearable onfocus="this.select()"
                :placeholder="$t('message.clientID')"></el-input>
            </div>
            <!--检品单号 -->
            <div class="Container">
              <el-input v-model="datas.inspect_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.inspectionOrderNumber')"></el-input>
            </div>
            <!--检品单类别 -->
            <div class="Container">
              <el-select v-model="datas.recheck" clearable onfocus="this.select()"
                :placeholder="$t('message.categoryOfInspectionList')">
                <!-- 首检 -->
                <el-option :label="$t('message.theFirstInspection')" value="1"></el-option>
                <!-- 复检 -->
                <el-option :label="$t('message.theReInspection')" value="2"></el-option>
              </el-select>
            </div>
            <!-- 检品单属性 -->
            <div class="Container">
              <el-select v-model="datas.type" clearable onfocus="this.select()"
                :placeholder="$t('message.singleAttributeOfInspection')">
                <!-- 普检 -->
                <el-option :label="$t('message.puJian')" value="1"></el-option>
                <!-- 精检 -->
                <el-option :label="$t('message.fineScreening')" value="2"></el-option>
              </el-select>
            </div>
            <!--检品员 -->
            <div class="Container">
              <el-select v-model="datas.j_id" clearable onfocus="this.select()"
                :placeholder="$t('message.testArticlePersonSelect')" filterable>
                <el-option :label="item.realname" :value="item.id" v-for="(item) in j" :key="item.id"></el-option>
              </el-select>
            </div>
            <div class="Container">
              <el-select v-model="datas.attribute" clearable filterable placeholder="SVIP">
                <el-option :label="item.label" :value="item.value" v-for="(item) in vipList" :key="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- 是否紧急 -->
            <div class="Container" v-if="datas.status == '2' || datas.status == '4' || datas.status == '6'">
              <el-select v-model="datas.overdue" :placeholder="$t('message.isOverdue')" filterable clearable
                @change="$forceUpdate()">
                <el-option :label="$t('message.all')" value="0">
                </el-option>
                <el-option :label="$t('message.overdue')" value="1">
                </el-option>
              </el-select>
            </div>
            <div class="Container">
              <!-- 检品 -->
              <el-button type="primary" @click="jianPin">{{
                $t("message.testArticle")
              }}</el-button>
              <!-- 搜索 -->
              <el-button type="primary" @click="search">{{
                $t("message.search")
              }}</el-button>
            </div>
            <!-- 新增服务单 -->
            <div class="rightContainer">
              <!-- 整番隐藏  -->
              <el-button @click="roundDisplay
              ">
                {{ isRoundDisplay ? $t("message.roundHide") : $t("message.roundDisplay") }}</el-button>
              <el-button type="success" @click="addServiceOrder" v-if="isAuth(767)">
                {{ $t("message.addServiceOrder") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="footer" v-if="datas.status != -1">
        <div class="footerContainer">
          <div class="table">
            <!-- 无数据显示 -->
            <div class="noData" v-if="tableData == false">暂无数据</div>
            <!-- 订单详情 -->
            <div class="detail" v-for="(orderItem, index) in tableData" :key="index">
              <div class="head">
                <div class="checkbox">
                  <el-checkbox v-model="orderItem.checked" @change="changeChecked(index)">
                  </el-checkbox>
                </div>
                <!-- 是否显示 -->
                <div class="show" @click="isShow(orderItem)">
                  <i class="el-icon-arrow-down" v-if="!orderItem.show"></i>
                  <i class="el-icon-arrow-up" v-else></i>
                </div>
                <!-- 提出时间 -->
                <div class="item">
                  {{ $t("message.forwardTime") }}：{{ orderItem.submit_at }}
                </div>
                <!-- 检品单号 -->
                <div class="item order">
                  {{ $t("message.inspectionOrderNumber") }}：
                  <router-link :to="'/generalInspectionListDetails?id=' + orderItem.inspect_sn
                    " target="_blank">
                    <span class="acli">
                      {{ orderItem.inspect_sn }}
                    </span>
                    <span style="font-size: 16px; text-decoration: none;" class="acli"> ({{ orderItem.typeName
                    }})</span>
                  </router-link>
                  <i class="el-icon-copy-document" @click="copy(orderItem.inspect_sn)"></i>
                </div>
                <div class="item">
                  <div style="width: 100px;height: 24px;">
                    <attributeName :name="orderItem.user_attribute" />
                  </div>
                  <!-- <span v-if="orderItem.user_attribute == '付费会员'" style="color: #fa5058;">({{ orderItem.user_attribute
                  }})</span>
                  <span v-else-if="orderItem.user_attribute == 'SVIP'" style="color: rgb(247, 226, 3);font-size: 25px;
                  font-weight: bold;">({{
                    orderItem.user_attribute
                  }})</span>
                  <span v-else-if="orderItem.user_attribute != ''">({{ orderItem.user_attribute }})</span> -->
                </div>
                <!-- 类别 -->
                <div class="item">
                  {{ $t("message.category") }}：{{ orderItem.recheckName }}
                </div>
                <!-- 配货 -->
                <div class="item">
                  {{ $t("message.distribution") }}：
                  {{ orderItem.p_admin != null ? orderItem.p_admin.realname : '' }}
                </div>
                <!-- 普/精检 -->
                <div class="item">
                  {{ orderItem.typeName }}：{{
                    orderItem.j_admin != null ? orderItem.j_admin.realname : ''
                  }}
                </div>
                <!-- 布标 -->
                <div class="item">
                  {{ $t("message.wovenLable") }}：{{
                    orderItem.label_admin != null
                      ? orderItem.label_admin.realname
                      : "无"
                  }}
                </div>
              </div>
              <div class="orderDetailOpt" v-for="(parcelItem, parcelIndex) in orderItem.groupByPurchaseNo"
                :key="parcelIndex" v-show="!orderItem.show">
                <div class="infoBox">
                  <!--  付款时间 -->
                  <div class="info time">
                    <!-- 客户付款时间 -->
                    <p>{{ $t("message.customerPaymentTime") }}</p>
                    {{ parcelItem.order_time_node.datetime_pay_confirm }}
                  </div>
                  <!-- 订单号 -->
                  <div class="info">
                    <p>
                      <router-link :to="'orderPaymentDetail?order_sn=' + parcelItem.order_sn
                        " target="_blank" class="a-link">
                        {{ parcelItem.order_sn }}
                      </router-link>
                    </p>
                    <p>{{ parcelItem.user != null ? parcelItem.user.realname : '' }}</p>
                  </div>
                  <!-- 交易号  -->
                  <div class="info" style="line-height: 40px">
                    <span>
                      {{ $t("message.transactionNumber") }}：
                      <a href="javascripr:;" class="a-link">
                        {{ parcelItem.purchase_no }}</a>
                      <i class="el-icon-copy-document" @click="copy(parcelItem.purchase_no)"></i>
                    </span>
                  </div>
                  <div class="info name">
                    <!-- 业务 -->
                    <span>{{ $t("message.business") }}：{{
                      parcelItem.y_admin != null ? parcelItem.y_admin.realname : ''
                    }}</span>
                    <!--  采购-->
                    <span>{{ $t("message.purchase") }}：{{
                      parcelItem.g_admin != null ? parcelItem.g_admin.realname : ''
                    }}</span>
                    <!-- 配货 -->
                    <span>{{ $t("message.distribution") }}：{{
                      parcelItem.p_admin != null ? parcelItem.p_admin.realname : ''
                    }}</span>
                  </div>
                </div>
                <ol>
                  <!-- 选择 -->
                  <li class="flex05">{{ $t("message.choose") }}</li>
                  <!-- 番号 -->
                  <li class="flex05">{{ $t("message.mash") }}</li>
                  <!--照片-->
                  <li>
                    {{ $t("message.pic") }}
                  </li>
                  <!-- 业务编辑商品属性 -->
                  <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
                  <!-- 附加服务 -->
                  <li class="additional-service">{{ $t("message.additionalServices") }}</li>
                  <!--应检数  -->
                  <li>{{ $t("message.quantityOfGoodsToBeSubmitted") }}</li>
                  <!-- 布标数  -->
                  <li>{{ $t("message.numberOfCloth") }}</li>
                  <!--已提交检品数  -->
                  <li>{{ $t("message.numberOfItemsSubmittedForInspection") }}</li>
                  <!-- 普检/精检问题数 -->
                  <li>
                    {{ $t("message.numberOfGeneralTestPrecisionTestProblems") }}
                  </li>
                  <!--布标问题数  -->
                  <li>{{ $t("message.numberOfLabelLayoutProblems") }}</li>
                  <!-- 价格.元 -->
                  <li>{{ $t("message.priceY") }}</li>
                  <!-- 物流号 -->
                  <li class="flex2">{{ $t("message.logisticsNumber") }}</li>
                  <!-- 担当备注 -->
                  <li class="flex15">
                    {{ $t("message.responsibleForRemarks") }}
                  </li>
                  <!-- 采购备注 -->
                  <li class="flex15">
                    {{ $t("message.purchasingNotes") }}
                  </li>
                  <!-- 核查员备注 -->
                  <li class="flex15">
                    {{ $t("message.verifierSNotes") }}
                  </li>
                  <!-- 状态 -->
                  <li>{{ $t("message.status") }}</li>
                </ol>
                <ul v-for="(goodsItem, indexs) in parcelItem.inspect_detail" :key="indexs">
                  <!-- 选择 -->
                  <li class="flex05">
                    <label>
                      <el-checkbox v-model="goodsItem.checked" @change="changeItem"></el-checkbox>
                    </label>
                  </li>
                  <li class="flex05">
                    {{ goodsItem.sorting }}
                  </li>
                  <!--照片-->
                  <li>
                    <div>
                      <div class="img">
                        <el-popover placement="right" width="300" trigger="hover">
                          <img :src="goodsItem.order_purchase.order_detail.pic" alt=""
                            style="width: 300px; height: 300px" />
                          <a :href="`https://detail.1688.com/offer/${goodsItem.order_purchase.order_detail.goods_id}.html`"
                            target="_blank" slot="reference">
                            <img :src="goodsItem.order_purchase.order_detail.pic" alt="" />
                          </a>
                        </el-popover>
                      </div>
                    </div>
                  </li>
                  <!-- 商品属性 -->
                  <li class="flex15">
                    <div class="template">
                      <p v-for="(skuItem, skuIndex) in goodsItem.order_purchase
                        .order_detail.detail_y" :key="skuIndex">
                        <span>{{ skuItem.key }}:</span>
                        <span>{{ skuItem.value }}</span>
                      </p>
                    </div>
                  </li>
                  <!-- 附加服务：一条一行 -->
                  <li class="additional-service">
                    <div class="additional-service-list">
                      <el-tag v-if="Number(goodsItem.order_purchase.order_detail.is_fba_pre) === 1" type="success" size="mini">标签前置处理</el-tag>
                      <p class="additional-service-item" v-for="(opti, optiIndex) in goodsItem.order_purchase
                        .order_detail.option" :key="optiIndex">
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}</span>
                        <span v-else>{{ opti.price }}%</span>
                      </p>
                    </div>
                  </li>
                  <!--应检数  -->
                  <li>
                    {{ goodsItem.num }}
                  </li>
                  <!-- 布标数  -->
                  <li class="numberOfgoodsItem">
                    <!-- 实缝标数 -->
                    <p> {{ $t("message.numberOfBidDemolitions") }}:{{ goodsItem.label_on }}</p>
                    <!-- 实拆标数 -->
                    <p> {{ $t("message.numberOfActualSplitBids") }}:{{ goodsItem.label_off }}</p>
                    <div class="time">
                      {{ goodsItem.label_start_at }}
                    </div>
                  </li>
                  <!--已提交检品数  -->
                  <li>
                    {{ goodsItem.inspect_num }}
                  </li>
                  <!-- 普检/精检问题数 -->
                  <li class="numberOfgoodsItem">
                    <!-- 实检数 -->
                    <p>
                      {{ $t("message.checkNumber") }}:{{
                        goodsItem.inspect_num
                      }}
                    </p>
                    <!-- 数量差 -->
                    <p>
                      {{ $t("message.poorQuantity") }}:{{
                        goodsItem.num - goodsItem.inspect_num
                      }}
                    </p>
                    <!-- 不良数 -->
                    <p>
                      {{ $t("message.adverseNumber") }}:{{
                        goodsItem.inspect_bad_num
                      }}
                    </p>
                  </li>
                  <!--布标问题数  -->
                  <li class="numberOfgoodsItem">
                    <!-- 应检数 -->
                    <p>
                      {{ $t("message.numberToBeChecked") }}:{{ goodsItem.num }}
                    </p>
                    <!-- 实检数 -->
                    <p>
                      {{ $t("message.checkNumber") }}:{{ goodsItem.label_num }}
                    </p>
                    <!-- 数量差 -->
                    <p>
                      {{ $t("message.poorQuantity") }}:{{
                        goodsItem.num - goodsItem.label_num
                      }}
                    </p>
                    <!-- 不良数 -->
                    <p>
                      {{ $t("message.adverseNumber") }}:{{
                        goodsItem.label_bad_num
                      }}
                    </p>
                  </li>
                  <!-- 价格.元 -->
                  <li>
                    {{ goodsItem.order_purchase.order_detail.confirm_price }}
                  </li>
                  <!-- 物流号 -->
                  <li class="flex2">
                    <div>
                      <p v-for="express in goodsItem.order_purchase
                        .order_purchase_express" :key="express.id">
                        {{ express.express_no }}
                      </p>
                    </div>
                  </li>
                  <!-- 担当备注 注:担当就是业务员-->
                  <li class="flex15">
                    {{ goodsItem.order_purchase.order_detail.y_remark }}
                  </li>
                  <!-- 采购商品备注 -->
                  <li class="flex15">
                    {{ goodsItem.order_purchase.order_detail.g_remark }}
                  </li>
                  <!-- 核查员备注 注:核查员就是配货-->
                  <li class="flex15">
                    {{ goodsItem.order_purchase.order_detail.p_remark }}
                  </li>
                  <!-- 状态 -->
                  <li>
                    <span class="a-link" @click="purchaseInspectDetail(goodsItem)">{{ goodsItem.statusName
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="operation">
            <div class="operation-left">
              <!-- 复制商品信息 -->
              <el-button type="primary" size="small" class="primary" @click="copyText">{{
                $t("message.copySelectedProductInformation") }}</el-button>
              <!-- 检品人员调配以检品单为单位选择，不使用商品明细的选中数量。 -->
              <div class="inspection-selection">
                <el-checkbox v-model="inspectionCheckedAll" @change="allInspectionChecked" />
                <span>{{ $t('message.allChecked') }}</span>
                <span>{{ $t('message.selectedInspectionOrderCount', { count: selectedInspectionOrders.length }) }}</span>
              </div>
            </div>
            <div class="btns">
              <el-button type="primary" size="small" v-if="isAuth(203)" @click="openBatchInspectionDispatch">
                {{ $t('message.batchDispatchInspector') }}
              </el-button>
              <!-- 取消检品 -->
              <el-button type="primary" size="small" class="fr secondary" @click="cancelInspection"
                v-if="isAuth(199)">{{ $t("message.cancelInspection") }}</el-button>
              <!-- 提出复检单（普检） -->
              <el-button type="primary" size="small" class="fr"
                @click="submitTheReinspectionList($t('message.generalInspectionReinspectionList')), ''"
                v-if="isAuth(211)">{{ $t("message.submitTheReinspectionListP") }}
              </el-button>
              <!-- 提出复检单（精检） -->
              <el-button type="primary" size="small" class="fr"
                @click="submitTheReinspectionList($t('message.fineRetestList'), 'J')" v-if="isAuth(211)">{{
                  $t("message.submitTheReinspectionListJ") }}</el-button>
            </div>
          </div>
          <!-- 分页 -->
          <div class="paginationContainer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="datas.page" :page-sizes="[20, 50, 100, 200]" :page-size="datas.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 服务单列表 -->
      <serviceList ref="serviceList" v-if="datas.status == '-1'" />
    </section>
    <!-- 复捡单 -->
    <listOfReinspection v-if="reinspectionDialogVisible" :list="reinspectionList" :type="reinspectionType" />
    <!-- 检品状态详情 -->
    <inspectDetail ref="inspectDetail" :tableData="inspectDetailList" />
    <!-- 创建服务单 -->
    <createServiceOrder ref="createServiceOrder" />
    <!-- 检品单批量调配 -->
    <batchInspectionAdminDispatch ref="batchInspectionAdminDispatch" @refresh="inspectList" />
  </div>
</template>
<script>
import listOfReinspection from "../components/listOfReinspection";
import batchInspectionAdminDispatch from '../components/batchInspectionAdminDispatch'
import { vipList } from '@/utlis/options'
import inspectDetail from '@/components/box/inspectDetail'
import serviceList from './serviceList'
import createServiceOrder from '@/components/common/createServiceOrder.vue'
export default {
  components: { listOfReinspection, batchInspectionAdminDispatch, inspectDetail, serviceList, createServiceOrder },
  data() {
    return {
      vipList,
      inspectListTab: {},
      datas: {
        page: 1,
        pageSize: 20,
        // 检品工种进入列表时默认查看待检品
        status: localStorage.getItem("japanUserRoleStatus") == 6 ? "2" : "0",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        order_sn: "",
        porder_sn: "",
        express_no: "",
        purchase_no: "",
        order_sn: "",
        order_part: "",
        overdue: '0'
      },
      tableData: [],
      total: 0,
      type: "",
      time: [],
      checked: false,
      checkedList: [], //选中的商品
      inspectionCheckedAll: false, //当前页检品单全选
      itemData: {}, //单番商品
      reinspectionDialogVisible: false,
      reinspectionList: [], //复检
      reinspectionType: "", //复捡类型
      isRoundDisplay: true,//整番是否显示
      inspectDetailList: [],//检品列表
      listTabCount: [
        {},
      ],//服务单
      optionKey: "",
    };
  },
  computed: {
    j() {
      let list = this.$store.state.authWorkGroupAdmin.j.filter(item => item.forbid_login == 0)
      return list
    },
    selectedInspectionOrders() {
      return this.tableData.filter(item => item.checked)
    },
  },
  created() {
    this.$api.inspectionApi.inspectListTab().then((res) => {
      this.inspectListTab = res.data
    })
    this.$api.inspectionApi.listTabCount().then((res) => {
      this.listTabCount = res.data
    })
    let query = this.$route.query
    if (query.status) {
      if (query.status == 0 || query.status == 10) {
        this.optionList(query.status - 0)
        return
      } else {
        this.datas.status = query.status
      }

    }
    if (query.overdue) {
      this.datas.overdue = query.overdue
    }
    if (query.inspect_sn) {
      this.datas.inspect_sn = query.inspect_sn
    }
    if (query.purchase_no) {
      this.datas.purchase_no = query.purchase_no
    }
    if (query.express_no) {
      this.datas.express_no = query.express_no
    }
    let that = this;
    // console.log(that.$route.name);
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.$route.name === 'menu3_follow_inspect_inspect' ? that.jianPin() : ''
        return false;
      }
    };
    this.inspectList();

  },
  methods: {
    // 提出复检单
    submitTheReinspectionList(title, type) {
      this.reinspectionList = [];
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      // 只能提交已检品完的
      for (let i = 0; i < this.checkedList.length; i++) {
        if (this.checkedList[i].status != 7) {
          this.$alert(
            this.checkedList[i].inspect_sn + "检品单正在检品中，无法提出复检单",
            "提示",
            {
              confirmButtonText: "确定",
              center: true,
            }
          );
          return false;
        }
      }
      //创建提交数据
      this.tableData.forEach((item) => {
        item.groupByPurchaseNo.forEach((items) => {
          let flag = items.inspect_detail.some((itemss) => itemss.checked);
          if (flag) {
            let itemsData = JSON.parse(JSON.stringify(items));
            itemsData.inspect_detail = [];
            items.inspect_detail.forEach((itemss) => {
              if (itemss.checked) {
                itemss.reinspection_num = itemss.num;
                let data = JSON.parse(JSON.stringify(itemss))
                itemsData.inspect_detail.push(data);
              }
            });
            this.reinspectionList.push(itemsData);
          }
        });
      });
      this.reinspectionType = title;
      this.reinspectionDialogVisible = true;
    },
    // 取消检品
    cancelInspection() {
      let checkedIdList = [];
      this.checkedList.forEach((checked) => {
        checkedIdList.push(checked.id);
      });
      this.$api.inspectionApi
        .inspectRemoveDetail({
          inspectDetailIdSet: checkedIdList,
        })
        .then((res) => {
          this.$message.success("成功");
          this.inspectList();
        });
    },
    // 获取列表
    inspectList() {
      this.$api.inspectionApi.inspectList(this.datas).then((res) => {
        // 为所有商品设置单选框参数
        res.data.data.forEach((orderItem) => {
          orderItem.checked = false;
          orderItem.groupByPurchaseNo.forEach((parcelItem) => {
            // parcelItem.show = true;
            parcelItem.inspect_detail.forEach((goodsItem) => {
              goodsItem.checked = false;
            });
          });
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.inspectionCheckedAll = false;
        this.checkedList = [];
      });
    },
    //搜索
    search() {
      this.optionKey = ''
      this.datas.page = 1;
      let that = this;
      document.onkeypress = function (e) {
        var keycode = document.all ? event.keyCode : e.which;
        if (keycode == 13) {
          that.$route.name === 'menu3_follow_inspect_inspect' ? that.jianPin() : ''
          return false;
        }
      };
      this.inspectList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.inspectList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.inspectList();
    },
    // 是否显示商品列表
    isShow(data) {
      data.show = !data.show;
      this.$forceUpdate();
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((orderItem) => {
        orderItem.groupByPurchaseNo.forEach((parcelItem) => {
          parcelItem.inspect_detail.forEach((goodsItem) => {
            if (goodsItem.checked) {
              goodsItem.typeName = orderItem.typeName;
              this.checkedList.push(goodsItem);
            }
          });
        });
      });
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checked = !this.checked;
      this.checkedList = [];
      this.tableData.forEach((orderItem) => {
        orderItem.groupByPurchaseNo.forEach((parcelItem) => {
          parcelItem.inspect_detail.forEach((goodsItem) => {
            goodsItem.checked = this.checked;
            if (goodsItem.checked) {
              goodsItem.typeName = orderItem.typeName;
              this.checkedList.push(goodsItem);
            }
          });
        });
      });
      this.$forceUpdate();
    },
    // 检品单全选
    changeChecked(index) {
      this.tableData[index].groupByPurchaseNo.forEach((parcelItem) => {
        parcelItem.inspect_detail.forEach((goodsItem) => {
          goodsItem.checked = this.tableData[index].checked;
        })
      });
      // 按整页勾选状态重建，避免只保留当前检品单导致多选丢失
      this.changeItem();
      this.inspectionCheckedAll = this.tableData.length > 0 && this.tableData.every(item => item.checked);
    },
    // 当前页检品单全选，同时保持原有商品勾选状态一致。
    allInspectionChecked(value) {
      this.tableData.forEach((orderItem) => {
        orderItem.checked = value;
        orderItem.groupByPurchaseNo.forEach((parcelItem) => {
          parcelItem.inspect_detail.forEach((goodsItem) => {
            goodsItem.checked = value;
          });
        });
      });
      this.changeItem();
    },
    openBatchInspectionDispatch() {
      if (!this.selectedInspectionOrders.length) {
        return this.$message.warning(this.$t('message.operationDataIsNotSelected'))
      }
      this.$refs.batchInspectionAdminDispatch.open(this.selectedInspectionOrders)
    },
    //检品
    jianPin() {
      if (this.datas.express_no == "" && this.datas.purchase_no == "")
        return false;
      let status;
      let routeUrl;
      if (this.datas.status == 4 || this.datas.status == 5) {
        status = "LABEL";
        routeUrl = this.$router.resolve({
          path:
            "/reinspectionListAndSubmission?express_no=" +
            this.datas.express_no +
            "&purchase_no=" +
            this.datas.purchase_no +
            "&status=" +
            status,
        });
      } else {
        status = "INSPECT";
        routeUrl = this.$router.resolve({
          path:
            "/operationInterfaceOfGeneralTestOrFineTestList?express_no=" +
            this.datas.express_no +
            "&purchase_no=" +
            this.datas.purchase_no +
            "&status=" +
            status,
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    //整番隐藏
    roundDisplay() {
      this.isRoundDisplay = !this.isRoundDisplay
      this.tableData.forEach(item => {
        item.show = !this.isRoundDisplay
      })
      this.$forceUpdate()
    },
    //检品详情
    purchaseInspectDetail(item) {
      let datas = {
        order_purchase_ids: [item.order_purchase_id]
      }
      this.$api.followApi.purchaseInspectDetail(datas).then(res => {
        this.inspectDetailList = res.data[0].inspect_detail
        this.$refs.inspectDetail.dialogVisible = true
      })
    },
    // 复制选中商品信息，支持多选；按番号排序后拼接
    copyText() {
      const selectedList = []
      this.tableData.forEach((orderItem) => {
        orderItem.groupByPurchaseNo.forEach((parcelItem) => {
          parcelItem.inspect_detail.forEach((goodsItem) => {
            if (goodsItem.checked) {
              selectedList.push({
                order_sn: goodsItem.order_purchase.order_sn,
                purchase_no: goodsItem.order_purchase.purchase_no,
                sorting: goodsItem.order_purchase.order_detail.sorting,
                link: goodsItem.order_purchase.order_detail.link,
              })
            }
          })
        })
      })
      if (selectedList.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      selectedList.sort((a, b) => Number(a.sorting) - Number(b.sorting))
      const copyUrl = selectedList.map(item => {
        return `${item.order_sn}\n${item.sorting}番  ${item.link}\n交易号: ${item.purchase_no}`
      }).join('\n')
      this.copy(copyUrl)
    },
    // 查看服务单列表
    optionList(key) {


      this.datas.status = '-1'
      this.optionKey = key
      this.$nextTick(() => {
        this.$refs.serviceList.datas.status = key
        this.$refs.serviceList.optionServiceList();
      })
    },
    // 新增服务单
    addServiceOrder() {
      let datas = {
        inspect_detail_ids: []
      }
      this.tableData.forEach((orderItem) => {
        orderItem.groupByPurchaseNo.forEach((parcelItem) => {
          // parcelItem.show = true;
          parcelItem.inspect_detail.forEach((goodsItem) => {
            if (goodsItem.checked) {
              datas.inspect_detail_ids.push(goodsItem.id)
            }
          });
        });
      });
      if (datas.inspect_detail_ids.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      this.$refs.createServiceOrder.optionServicePreview(datas)
      this.$refs.createServiceOrder.dialogVisible = true
    },
  },
};
</script>

<style lang='scss' scoped>
@import "@/css/mixin";

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }
}

section {
  position: relative;

  .header {
    padding: 0;
  }

  .headerContainer {
    background-color: #f6f6f6 !important;
    padding: 0 !important;

    .option {
      position: absolute;
      top: 24px;
      right: 24px;
      display: flex;

      .item {
        margin-left: 10px;
        cursor: pointer;
        background-color: #fff;
        color: #333;
        padding: 10px 15px;
        border-radius: 5px;
      }

      .optionKey {
        background-color: #f56c6c;
        color: #fff;
      }
    }
  }

  .footer {
    padding: 0;
    background-color: #f6f6f6 !important;

    .footerContainer {
      padding: 0;
    }
  }
}

.leftContainer {
  width: 100% !important;
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .rightContainer {
    position: absolute;
    top: 60px;
    right: 0px;
  }

  .Container {
    margin-right: 20px;
    margin-bottom: 20px;
    width: 200px;

    /deep/.el-date-editor {
      width: 200px;
    }

    /deep/.el-input__inner {
      width: 200px;
    }
  }

  .time {
    margin-right: 20px;
  }
}

.table {
  margin-top: 24px;

  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin-bottom: 20px;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;

    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;

    .template {
      max-height: 100px;
      overflow: hidden;
    }
  }

  .numberOfgoodsItem {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .time {
      display: flex;
      width: 70px;
    }
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .additional-service {
    flex: 2;
  }

  .additional-service-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    text-align: left;
  }

  .additional-service-item {
    margin: 0;
    white-space: nowrap;
  }

  .detail {
    .head {
      height: 60px;
      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      .checkbox {
        width: 50px;

        display: flex;
        justify-content: center;
        align-items: center;
      }

      .show {
        flex: 0.3;
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 16px;
        }
      }

      .item {
        flex: 1;
        line-height: 20px;
        padding: 10px;
        display: flex;
        align-items: center;

        span {
          margin-right: 30px;
        }

        .acli {
          cursor: pointer;
          color: #f9ff57;
          text-decoration: underline;
        }
      }

      .order {
        flex: 2.3;
      }

      .name {
        flex: 3;
        line-height: 40px;
      }


    }

    .infoBox {
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 20px;
      border-bottom: solid 1px #d2d2d2;

      .info {
        margin-right: 40px;

        span {
          margin-right: 40px;
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

.operation {
  background-color: #edeff4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  position: sticky;
  bottom: 0;
  z-index: 99;

  .btns {
    padding-top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .operation-left,
  .inspection-selection {
    display: flex;
    align-items: center;
  }

  .inspection-selection {
    gap: 16px;
    margin-left: 24px;
  }

  .el-button {
    margin-left: 30px;
  }
}

/deep/ .el-textarea__inner {
  height: 80px;
  padding: 0 2px;
  line-height: 18px;
}
</style>
